/**
 * @generated SignedSource<<bd88be8910022454af423618cd454804>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductTile_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_user">;
  readonly " $fragmentType": "BuyerProductTile_user";
};
export type BuyerProductTile_user$key = {
  readonly " $data"?: BuyerProductTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductTile_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductBaseTile_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "402e94ea3d3dd3aed750fe1a76ee2c41";

export default node;
